function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 7.50001V5.00001C14.1667 5.00001 12.2433 4.84334 11.245 6.84668L7.73 13.8975C6.88417 15.5942 5.15167 16.6667 3.255 16.6667H0V15H3.255C4.51917 15 5.67417 14.285 6.23833 13.1533L9.75333 6.10251C10.8833 3.83501 12.815 3.33334 15 3.33334V0.833344L20 4.16668L15 7.50001V7.50001ZM7.11417 8.60334L8.045 6.73501C7.01583 4.66918 5.62917 3.33334 3.255 3.33334H0V5.00001H3.255C5.64833 5.00001 6.29167 6.95251 7.11417 8.60334V8.60334ZM20 15.8333L15 12.5V15C11.85 15 11.6508 13.9683 10.37 11.3983L9.43833 13.2658C10.2892 14.9733 11.1883 16.6667 15 16.6667V19.1667L20 15.8333Z",
  fill: "#CCCCCC"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

function SvgRandom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandom);
export default __webpack_public_path__ + "static/media/random.ca5a5f70.svg";
export { ForwardRef as ReactComponent };